import React, { useState, useEffect } from "react";
import PackageJson from "../../package.json";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { userService } from "../services/user.service";
import { userStore } from "../gStore/user.store";

export type WOWSEEAVATAR = {
    editable?: boolean;
}

const avatars = [
    `${PackageJson.homepage}/avatars/Asset 3.png`,
    `${PackageJson.homepage}/avatars/Asset 4.png`,
    `${PackageJson.homepage}/avatars/Asset 5.png`,
    `${PackageJson.homepage}/avatars/Asset 6.png`,
    `${PackageJson.homepage}/avatars/Asset 7.png`,
    `${PackageJson.homepage}/avatars/Asset 8.png`,
    `${PackageJson.homepage}/avatars/Asset 9.png`,
    `${PackageJson.homepage}/avatars/Asset 10.png`,
    `${PackageJson.homepage}/avatars/Asset 11.png`,
    `${PackageJson.homepage}/avatars/Asset 12.png`,
    `${PackageJson.homepage}/avatars/Asset 13.png`,
    `${PackageJson.homepage}/avatars/Asset 14.png`,
    `${PackageJson.homepage}/avatars/Asset 15.png`,
    `${PackageJson.homepage}/avatars/Asset 16.png`,
    `${PackageJson.homepage}/avatars/Asset 17.png`,
    `${PackageJson.homepage}/avatars/Asset 18.png`,
    `${PackageJson.homepage}/avatars/Asset 19.png`,
    `${PackageJson.homepage}/avatars/Asset 20.png`,
    `${PackageJson.homepage}/avatars/Asset 21.png`,
    `${PackageJson.homepage}/avatars/Asset 22.png`,
    `${PackageJson.homepage}/avatars/Asset 23.png`,
    `${PackageJson.homepage}/avatars/Asset 24.png`,
    `${PackageJson.homepage}/avatars/Asset 25.png`,
    `${PackageJson.homepage}/avatars/Asset 26.png`,
    `${PackageJson.homepage}/avatars/Asset 27.png`,
    `${PackageJson.homepage}/avatars/Asset 28.png`,
    `${PackageJson.homepage}/avatars/Asset 29.png`,
    `${PackageJson.homepage}/avatars/Asset 30.png`,
    `${PackageJson.homepage}/avatars/Asset 31.png`,
    `${PackageJson.homepage}/avatars/Asset 32.png`,
    `${PackageJson.homepage}/avatars/Asset 33.png`,
    `${PackageJson.homepage}/avatars/Asset 34.png`,
    `${PackageJson.homepage}/avatars/Asset 35.png`,
    `${PackageJson.homepage}/avatars/Asset 36.png`,
    `${PackageJson.homepage}/avatars/Asset 37.png`,
    `${PackageJson.homepage}/avatars/Asset 38.png`,
    `${PackageJson.homepage}/avatars/Asset 39.png`,
    `${PackageJson.homepage}/avatars/Asset 40.png`,
    `${PackageJson.homepage}/avatars/Asset 41.png`,
    `${PackageJson.homepage}/avatars/Asset 42.png`,
]

export const WowseeAvatar = ({ editable }: WOWSEEAVATAR) => {
    const [open, setOpen] = useState(false);
    const [pickedAvatar, setPickedAvatar] = useState<string>("");
    const onOpenModal = () => setOpen(true);
    const onCloseModal = () => setOpen(false);
    useEffect(() => {
        setPickedAvatar(userStore.data.user.avatar);
    }, []);
    const updateAvatar = () => {
        userService.updateUserAvatar(userStore.data.user.id, pickedAvatar).then((success) => {
            if (success) {
                userStore.updateUserAvatar({ payload: { avatar: pickedAvatar }});
                onCloseModal();
            } else {
                alert("Failed to update avatar");
            }
        });
    }
    return (
        <div className="px-auto text-center relative w-40 h-40">
            <div className="w-40 h-40 rounded-full overflow-hidden flex items-center">
                <img className="mx-auto" src={userStore.data.user.avatar} alt="" />
            </div>
            {editable && (
                <>
                <div className="absolute -right-1 -bottom-1 w-7 h-7 flex justify-center items-center border-black border-2 border-solid rounded-full bg-white" onClick={onOpenModal}>
                    <img src={`${PackageJson.homepage}/icons/eva_edit-2-fill.svg`} alt="Edit" />
                </div>
                <Modal open={open} onClose={onCloseModal} center showCloseIcon={false} classNames={{ modal: 'bg-white' }} styles={{ modal: { padding: 0, margin: 0 } }}>
                    <div className="bg-dark1 p-6 flex flex-col gap-4 relative">
                        <div className="absolute left-6 top-6">
                            <button className="flex justify-center items-center gap-4 text-white font-bold" onClick={onCloseModal}>
                                <img src={`${PackageJson.homepage}/icons/left-arrow.svg`} alt="left" />
                                <span>Back</span>
                            </button>
                        </div>
                        <div className="flex justify-center w-full space-x-10 text-white text-xl font-bold">
                            Change Profile
                        </div>

                        <div className="grid grid-cols-8 gap-4">
                            {avatars.map((avatar, i) => (
                                <div key={i} className={`relative ${pickedAvatar === avatar ? 'opacity-75' : ''}`}>
                                    {pickedAvatar === avatar && (
                                        <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                            <img src={`${PackageJson.homepage}/icons/check.svg`} alt="Check" />
                                        </div>
                                    )}
                                    <img key={i} src={avatar} alt="" onClick={() => setPickedAvatar(avatar)} />
                                </div>
                            ))}
                        </div>

                        <div className="flex justify-end space-x-1">
                            <button onClick={onCloseModal} className="border-primary-blue  border py-2 px-3 rounded-md text-xs text-primary-blue font-semibold">Cancel</button>
                            <button className="bg-primary-blue py-2 px-3 rounded-md text-xs text-white font-semibold" onClick={updateAvatar}>Change Image</button>
                        </div>
                    </div>
                </Modal>
                </>
            )}
        </div>
    )
}